<div class="fields">
  <ng-content></ng-content>
</div>
